import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { MenuItem } from 'primeng/api';

import { PropertyListItem, HeaderSummary } from './property';
import { environment } from './../../environments/environment';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { GlobalService } from '../core/global.service';
import { catchError } from 'rxjs/operators';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
};

@Injectable({
  providedIn: 'root'
})
export class PropertyService {

  constructor(private _http: HttpClient, private _global: GlobalService) { }

  getRecentProperties(): Observable<PropertyListItem> {
    const api = (<any>_GlobalNS).api.property.recentProperties;
    const url = `${api}`;
    return this._http.get<PropertyListItem>(url);
  }

  getPropertyActivityMenuItems(propertyId): MenuItem[] {
    const items: MenuItem[] = [{ id: '1' }, { id: '2' }];
    items.map((i) => {
      i.label = (i.id === '1') ? 'Open in New Window' : 'Open Property';
      i.url = this.getPropertyViewUri(propertyId);
      i.target = (i.id === '1') ? '_blank' : '_self';
    });
    return items;
  }

  getPropertyViewUri(propertyId: number): string {
    const api = (<any>_GlobalNS).routes.property.viewTasks;
    const buildUri = `${api}&property_id=${propertyId}`;
    return buildUri;
  }

  getFavoritePropertiesSearchUri(): string {
    const api = (<any>_GlobalNS).routes.property.search;
    const favPropertiesSearchUri = `${api}&FavoritesOnly=1`;
    return favPropertiesSearchUri;
  }

  getDataPropertyById(): Observable<PropertyListItem> {
    const api = (<any>_GlobalNS).api.property.header;
    const propertyId = this._global.find((<any>_GlobalNS).paths.PropertyId);
    const url = (environment.production) ? `${api}&PropertyId=${propertyId}` : `${api}?PropertyId=1`;

    return this._http.get<PropertyListItem>(url);
  }

  /*
  Get Property HeaderSummary DataPoints
  */
  HeaderSummary(source: string, strategy?: string): Observable<HeaderSummary[]> {
    const api = (<any>_GlobalNS).api.property.header;
    const propertyId = this._global.find((<any>_GlobalNS).paths.PropertyId);
    const params = new HttpParams()
      .set('propertyId', propertyId.toString())
      .set('source', source)
      .set('displayArea', strategy);
    return this._http.get<any>(`${api}`, { params }).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  }
  
}
